'use client'
import React, { forwardRef } from 'react'

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { STATE_LIST } from '@/utils/state-list'

// Dropdown props
interface StateDropdownProps {
  onChange?: (stateValue: string | null) => void
  defaultValue?: string
  disabled?: boolean
  placeholder?: string
  value?: string
  name?: string
  onBlur?: () => void
  className?: string
  'aria-invalid'?: boolean | 'true' | 'false'
}

const StateDropdownComponent = (
  {
    onChange,
    defaultValue,
    disabled = false,
    placeholder = 'Select state *',
    value,
    name,
    onBlur,
    className,
    ...props
  }: StateDropdownProps,
  ref: React.ForwardedRef<HTMLButtonElement>,
) => {
  return (
    <Select value={value || defaultValue} onValueChange={onChange} disabled={disabled} name={name}>
      <SelectTrigger ref={ref} className={className} onBlur={onBlur} aria-invalid={props['aria-invalid']}>
        <SelectValue placeholder={placeholder}>
          {(value: string) => STATE_LIST.find((s) => s.value === value)?.label ?? value}
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        {STATE_LIST.map((state) => (
          <SelectItem key={state.value} value={state.value}>
            {state.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}

StateDropdownComponent.displayName = 'StateDropdownComponent'

export const StateDropdown = forwardRef(StateDropdownComponent)
